import { render, staticRenderFns } from "./VSelectRangeInput.vue?vue&type=template&id=52a2820c&scoped=true&"
import script from "./VSelectRangeInput.vue?vue&type=script&lang=js&"
export * from "./VSelectRangeInput.vue?vue&type=script&lang=js&"
import style0 from "./VSelectRangeInput.vue?vue&type=style&index=0&id=52a2820c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a2820c",
  null
  
)

export default component.exports